import { SheetGroup } from '../../../types';
import {
  AddSheetToGroup,
  CreateSheetGroup,
  DeleteSheetGroup,
  RemoveSheetFromGroup,
  SheetGroupsCommand,
  SheetGroupsCommandType,
} from '../../../types/commands/sheetGroupsCommands/sheetGroupCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import { saveCreationEvent, saveDeletionEvent } from './common';

// #region helpers
const saveActionPair = (
  set: SheetManagementSet,
  groupId: string,
  action: SheetGroupsCommand,
  undoAction?: SheetGroupsCommand
) => {
  if (!set.present.groupCommands) set.present.groupCommands = new Map();

  if (!set.present.groupCommands.has(groupId))
    set.present.groupCommands.set(groupId, []);
  set.present.groupCommands.get(groupId)?.push(action);

  if (!set.past.groupCommands) set.past.groupCommands = new Map();

  if (undoAction) {
    if (!set.past.groupCommands.has(groupId))
      set.past.groupCommands.set(groupId, []);
    set.past.groupCommands.get(groupId)?.push(undoAction);
  }
};

// #endregion

// #region create & delete group
export const createGroupCommand = (
  set: SheetManagementSet,
  group: SheetGroup,
  allowOpposite = true
) => {
  const action: CreateSheetGroup = {
    type: SheetGroupsCommandType.CreateGroup,
    group,
  };

  if (allowOpposite) {
    const reverse = deleteGroupCommand(set, group, false);
    saveCreationEvent(set, action, reverse);
    return;
  }

  return action;
};

export const deleteGroupCommand = (
  set: SheetManagementSet,
  group: SheetGroup,
  allowOpposite = true
) => {
  const action: DeleteSheetGroup = {
    type: SheetGroupsCommandType.DeleteGroup,
    groupId: group.id,
  };

  if (allowOpposite) {
    const reverse = createGroupCommand(set, group, false);
    saveDeletionEvent(set, action, reverse);
    return;
  }

  return action;
};
// #endregion

// #region add remove sheet
export const addSheetToGroupCommand = (
  set: SheetManagementSet,
  groupId: string,
  sheetId: string,
  allowOpposite = true
) => {
  const action: AddSheetToGroup = {
    type: SheetGroupsCommandType.AddSheetToGroup,
    groupId,
    sheetId,
  };

  if (allowOpposite) {
    const reverse = removeSheetFromGroupCommand(set, groupId, sheetId, false);
    saveActionPair(set, groupId, action, reverse);

    return;
  }

  return action;
};

export const removeSheetFromGroupCommand = (
  set: SheetManagementSet,
  groupId: string,
  sheetId: string,
  allowOpposite = true
) => {
  const action: RemoveSheetFromGroup = {
    type: SheetGroupsCommandType.RemoveSheetFromGroup,
    groupId,
    sheetId,
  };

  if (allowOpposite) {
    const reverse = addSheetToGroupCommand(set, groupId, sheetId, false);
    saveActionPair(set, groupId, action, reverse);

    return;
  }

  return action;
};
// #endregion
